<template>
    <div style="padding: 50px 18px 18px; ">
        <div class="row mb-2">
            <div class="col-12">
                <a href="javascript:void(0)" @click="close" class="float-left">&lt;&lt; Back to messages</a>
            </div>
        </div>
        <div class="row" v-if="!(emailPreview && emailPreview.messageHtml) && showApproveTemplate">
            <div class="col-12">
                <div v-if="!claimHasStatus(1009) && !claimHasStatus(1011)"
                     class="row">
                    <div class="col">
                        <p><i class="fas fa-info-circle mr-2"></i>The Claim has to be APPROVED before a Claim Approved email can be sent.  Select the Update Claim tab.</p>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col">
                            <p>Approval email last sent: {{approvedEmailLastSent}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="approvalReason"><strong>Message to appear in email (visible to claimant!)</strong></label>
                                <wysiwyg id="approvalReason" v-model="approvalReason" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="checkbox"
                                               class="form-check-input mb-2"
                                               v-model="approvalIncludeLink">
                                        Include settlement options link
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!(emailPreview && emailPreview.messageHtml) && showDeclineTemplate">
            <div class="col-12">
                <div v-if="!claimHasStatus(1024)"
                     class="row">
                    <div class="col">
                        <p><i class="fas fa-info-circle mr-2"></i>The Claim has to be DECLINED before a Claim Declined email can be sent.  Select the Update Claim tab.</p>
                    </div>
                </div>
                <div v-else>
                    <div class="row">
                        <div class="col">
                            <p>Declined email last sent: {{declinedEmailLastSent}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="declinationReason"><strong>Reason the claim has been declined (visible to claimant!)</strong></label>
                                <wysiwyg v-model="reason" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!(emailPreview && emailPreview.messageHtml) && showDocsTemplate">
            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <div class="form-group">
                            <label for="moreDocumentationReason"><strong>Message to appear in email (visible to claimant!)</strong></label>
                            <wysiwyg id="moreDocumentationReason" v-model="moreDocumentationReason" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="">
                            <p>Select the type of documents that you wish the claimant to provide.</p>
                            <div class="form-group row">
                                <label class="col-sm-4 col-form-label"
                                       :for="'selectedTemplate'">
                                    Document type group
                                </label>
                                <div class="col-sm-8">
                                    <b-form-select v-model="selectedTemplate" :options="templates" size="sm" class="">
                                        <template slot="first">
                                            <option :value="null" disabled>-- Please select a document type group --</option>
                                        </template>
                                    </b-form-select>
                                </div>
                            </div>
                            <p><a href="javascript:void(0)" @click="handleShowTipsLinkClick">{{showTipsLinkText}}</a></p>
                            <p style="padding-left: 5px;"><i class="fas fa-info-circle mr-2"></i>Tips will appear in the email to the customer.</p>
                            <div v-for="(type, index) in documentTypes" :key="index" class="form-check">
                                <label class="form-check-label">
                                    <input type="checkbox"
                                           class="form-check-input mb-2"
                                           @click="handleDocumentTypeClick(type)"
                                           :checked="documentTypeSelected(type.id)"
                                           value="">{{type.label}}
                                </label>
                                <transition name="fade">
                                    <textarea v-if="showTips" id="" class="form-control form-control-sm mb-2" rows="4" :value="type.tip" disabled></textarea>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!(emailPreview && emailPreview.messageHtml) && showClaimPaymentTemplate">
            <div class="col-12">
                <div>
                    <!--<div class="row">
                        <div class="col">
                            <p>Approval email last sent: {{approvedEmailLastSent}}</p>
                        </div>
                    </div>-->
                    <!--<div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="approvalReason"><strong>Message to appear in email (visible to claimant!)</strong></label>
                                <wysiwyg id="approvalReason" v-model="approvalReason" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="">
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input type="checkbox"
                                               class="form-check-input mb-2"
                                               v-model="approvalIncludeLink">
                                        Include repair options link
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div v-if="emailPreview && emailPreview.messageHtml" class="embed-responsive embed-responsive-16by9">
                    <iframe class="embed-responsive-item"
                            :src="getBlobURL(emailPreview.messageHtml, 'text/html')"></iframe>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="float-right">
                    <button type="button" class="btn btn-primary mr-2" @click="previewClick()">Preview</button>
                    <button type="button" class="btn btn-primary mr-2" @click="sendEmailClick()">Send</button>
                    <button type="button" class="btn btn-primary" @click="handleCancelClick()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '@/messageEventBus.js';
    import { SEND_EMAIL, SEND_EMAIL_COMPLETE } from '@/messageEvents.js';

    import { NEW_APPROVE_TEMPLATE, NEW_DECLINE_TEMPLATE, NEW_DOCS_TEMPLATE, NEW_CLAIM_PAYMENT_TEMPLATE } from './composeActionTypes.js';

    import { mapActions } from 'vuex'

    String.prototype.hashCode = function () {
        var hash = 0, i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
            chr = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    };

    export default {
        name: "message-compose-templates",
        props: {
            eventTarget: {
                type: String,
                required: true
            },
            templateType: {
                type: String,
                required: true
            }
        },
        data: () => {
            return {
                moreDocumentationReason: null,
                selectedDocumentTypes: [],
                showTips: false,
                selectedTemplate: null,

                previewClicked: false,

                templates: [{
                    value: [1000],
                    text: 'POP'
                },
                {
                    value: [1003],
                    text: 'POD'
                },
                {
                    value: [1005],
                    text: 'POP'
                },
                {
                    value: [1000, 1003],
                    text: 'POP_POD'
                },
                {
                    value: [1003, 1005],
                    text: 'POD_POU'
                },
                {
                    value: [1000, 1003, 1005],
                    text: 'POP_POD_POU'
                },
                {
                    value: [1004],
                    text: 'POT'
                },
                {
                    value: [1005],
                    text: 'POU'
                },
                {
                    value: [1006],
                    text: 'POI'
                },
                {
                    value: [1000, 1004],
                    text: 'POP_POT'
                },
                {
                    value: [1000, 1006],
                    text: 'POP_POI'
                },
                {
                    value: [1000, 1003, 1004],
                    text: 'POP_POD_POT'
                },
                {
                    value: [1000, 1003, 1005, 1006],
                    text: 'POP_POD_POU_POI'
                },
                {
                    value: [1000, 1003, 1005, 1006, 1004],
                    text: 'POP_POD_POU_POI_POT'
                },
                {
                    value: [1000, 1003, 1004, 1006],
                    text: 'POP_POD_POT_POI'
                },
                {
                    value: [1000, 1003, 1006],
                    text: 'POP_POD_POI'
                },
                {
                    value: [1003, 1004],
                    text: 'POD_POT'
                },
                {
                    value: [1004, 1006],
                    text: 'POT_POI'
                }],

                selectedDeclinationReason: null,
                sendDeclinedEmail: false,              

                approvalReason: null,
                approvalIncludeLink: false,

                to: '',
                subject: '',
                body: ''
            };
        },
        watch: {
            'selectedTemplate': function (newVal) {
                if (newVal) {
                    this.selectedDocumentTypes = []
                    for (let i = 0; i < newVal.length; i++) {
                        let item = this.documentTypes.find(o => o.id == newVal[i])
                        if (item)
                            this.selectedDocumentTypes.push(item)
                    }
                }
            }
        },
        computed: {
            selectedClaim() {
                return this.$store.getters.selectedClaim
            },
            approvedEmailLastSent() {
                let obj = this.getLatestEmail(1003)
                return obj ? obj.dateCreated : null
            },
            declinedEmailLastSent() {
                let obj = this.getLatestEmail(1004)
                return obj ? obj.dateCreated : null
            },
            requestDocsEmailLastSent() {
                let obj = this.getLatestEmail(1005)
                return obj ? obj.dateCreated : null
            },
            documentTypes() {
                return this.$store.getters.documentTypes
            },
            emailPreview() {
                return this.$store.getters.emailPreview
            },
            showTipsLinkText() {
                return this.showTips ? '[- Hide document type tips below]' : '[+ Show document type tips below]'
            },
            showDocsTemplate() {
                return this.templateType == NEW_DOCS_TEMPLATE
            },
            showApproveTemplate() {
                return this.templateType == NEW_APPROVE_TEMPLATE
            },
            showDeclineTemplate() {
                return this.templateType == NEW_DECLINE_TEMPLATE
            },
            showClaimPaymentTemplate() {
                return this.templateType == NEW_CLAIM_PAYMENT_TEMPLATE
            }
        },
        methods: {
            ...mapActions([
                'requestMoreDocs',
                'requestMoreDocsEmailPreview',
                'approveClaim',
                'approveClaimPreview',
                'declineClaim',
                'declineClaimEmailPreview',
                'resetEmailPreview',
                'claimPaymentEmailPreview',
                'sendClaimPaymentEmail'
            ]),
            handleRequestMoreDocsClick() {
                let { claimId } = this.selectedClaim
                let { selectedDocumentTypes } = this
                this.selectedDocumentTypes = []
                let { moreDocumentationReason } = this
                let sendEmail = true

                this.requestMoreDocs({ claimId, selectedDocumentTypes, reason: moreDocumentationReason, sendEmail })
            },
            previewClick(template) {
                this.previewClick = true

                switch (this.templateType) {
                    case NEW_APPROVE_TEMPLATE:
                        this.handleApproveclaimPreviewClick()
                        break;
                    case NEW_DECLINE_TEMPLATE:
                        this.handleDeclineclaimPreviewClick()
                        break;
                    case NEW_DOCS_TEMPLATE:
                        this.handleRequestMoreDocsPreviewClick();
                        break;
                     case NEW_CLAIM_PAYMENT_TEMPLATE:
                        this.handleClaimPaymentPreviewClick();
                        break;
                }

            },
            handleClaimPaymentPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                //let { approvalReason: messageText, approvalIncludeLink: includeRepairOptionsLink } = this

                this.claimPaymentEmailPreview({
                    claimId,
                    //messageText,
                    //includeRepairOptionsLink
                })
            },
            handleApproveclaimPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { approvalReason: messageText, approvalIncludeLink: includeRepairOptionsLink } = this

                this.approveClaimPreview({
                    claimId,
                    messageText,
                    includeRepairOptionsLink
                })
            },
            handleRequestMoreDocsPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { selectedDocumentTypes } = this
                let { moreDocumentationReason } = this
                let sendEmail = true

                this.requestMoreDocsEmailPreview({ claimId, selectedDocumentTypes, reason: moreDocumentationReason, sendEmail })
            },
            handleDeclineclaimPreviewClick() {
                this.resetEmailPreview()
                let { claimId } = this.selectedClaim
                let { reason, selectedDeclinationReason } = this
                let sendEmail = this.sendDeclinedEmail

                this.declineClaimEmailPreview({
                    claimId,
                    reason: selectedDeclinationReason ? selectedDeclinationReason.id : null,
                    messageText: reason,
                    sendEmail
                })
            },
            getLatestEmail(typeId) {
                let { emailHistoryDetails } = this.selectedClaim
                if (emailHistoryDetails) {
                    let emails = typeId ? emailHistoryDetails.filter(email => email.emailTypeId == typeId) : emailHistoryDetails

                    let maxDate = Math.max.apply(null, emails.map((e) => {
                        return new Date(e.dateCreated);
                    }));
                    let latest = emails.filter(a => { let dte = new Date(a.dateCreated).getTime(); return dte == maxDate; })
                    return latest[0]
                }
            },
            claimHasStatus(statusId) {
                let { claimStatusDetails } = this.selectedClaim
                if (claimStatusDetails) {
                    return claimStatusDetails.filter(o => o.statusId == statusId).length > 0
                }
                return false
            },
            handleCancelClick() {
                if (this.previewClick == true) {
                    this.resetEmailPreview(null)
                    this.previewClick = false
                } else {
                    this.close()
                }
            },
            close() {
                this.$emit("closePanel");
            },
            getMessageHashCode() {
                let { to, subject } = this
                let base = to + subject + new Date().getTime()
                return base.hashCode()
            },
            sendEmailClick() {
                switch (this.templateType) {
                    case NEW_APPROVE_TEMPLATE:
                        this.handleApproveclaimClick()
                        break;
                    case NEW_DECLINE_TEMPLATE:
                        this.handleDeclineclaimClick()
                        break;
                    case NEW_DOCS_TEMPLATE:
                        this.handleRequestMoreDocsClick();
                        break;
                    case NEW_CLAIM_PAYMENT_TEMPLATE:
                        this.handleClaimPaymentClick();
                        break;
                }
                this.close()
            },
            handleClaimPaymentClick() {
                let { claimId } = this.selectedClaim
                let { selectedDocumentTypes } = this
                this.selectedDocumentTypes = []
                let { moreDocumentationReason } = this
                let sendEmail = true

                this.sendClaimPaymentEmail({ claimId, sendEmail })
            },
            handleRequestMoreDocsClick() {
                let { claimId } = this.selectedClaim
                let { selectedDocumentTypes } = this
                this.selectedDocumentTypes = []
                let { moreDocumentationReason } = this
                let sendEmail = true

                this.requestMoreDocs({ claimId, selectedDocumentTypes, reason: moreDocumentationReason, sendEmail })
            },
            handleDeclineclaimClick() {
                let { claimId } = this.selectedClaim
                let { reason, selectedDeclinationReason } = this
                let sendEmail = this.sendDeclinedEmail

                this.declineClaim({
                    claimId,
                    reason: selectedDeclinationReason ? selectedDeclinationReason.id : null,
                    messageText: reason,
                    sendEmail
                })
            },
            handleApproveclaimClick() {
                let { claimId } = this.selectedClaim
                let { approvalReason: messageText, approvalIncludeLink: includeRepairOptionsLink } = this

                this.approveClaim({
                    claimId,
                    messageText,
                    includeRepairOptionsLink
                })

                this.approvalReason = null
                this.approvalIncludeLink = false
            },
            handleDocumentTypeClick(item) {
                if (this.selectedDocumentTypes.includes(item)) {
                    this.selectedDocumentTypes.splice(this.selectedDocumentTypes.indexOf(item), 1)
                } else {
                    this.selectedDocumentTypes.push(item)
                }
                this.selectedTemplate = null
            },
            handleShowTipsLinkClick() {
                this.showTips = !this.showTips
            },
            documentTypeSelected(id) {
                for (var i = 0; i < this.selectedDocumentTypes.length; i++) {
                    if (this.selectedDocumentTypes[i].id === id) {
                        return true
                    }
                }
                return false
            },
            getBlobURL(code, type) {
                const blob = new Blob([code], { type })
                return URL.createObjectURL(blob)
            },
        },
        beforeMount() {
            this.resetEmailPreview(null)
        }
    };
</script>

